import React, { useEffect, useState } from "react";
import Layout from "components/Layout";
import { Box, Text } from "@chakra-ui/react";
import Head from "next/head";

const TermOfService: React.FC = () => {
  const [termsOfUse, setTermsOfUse] = useState<string>("");

  useEffect(() => {
    fetch(
      "https://d1c9i2hjt1qll5.cloudfront.net/htmls/legaldocuments/101d_TermsofUse.html"
    )
      .then((data) => data.text())
      .then((html) => setTermsOfUse(html));
  }, []);

  return (
    <Layout>
      <Head>
        <title>101Digital | Terms of Service</title>
      </Head>
      <Text
        as="h1"
        textStyle="h1"
        textAlign={["center", null, null, null, null, "left"]}
        mb={["34px", null, null, null, null, "136px"]}
        mt={["50px", null, null, null, null, "132px"]}
      >
        <Text>Terms of Service</Text>
      </Text>
      <Box
        maxW="1155px"
        w="100%"
        mb={["34px", null, null, null, null, "99px"]}
        px={["28px", null, null, null, null, "16px"]}
      >
        <Text
          textStyle="paragraph"
          color="primary"
          fontSize={["12px", null, null, null, null, "21px"]}
        >
          {termsOfUse && (
            <Box
              dangerouslySetInnerHTML={{ __html: termsOfUse }}
              sx={{
                p: { fontWeight: 300, fontSize: "21px" },
                h3: {
                  fontWeight: 700,
                  fontSize: "21px",
                  marginTop: "64px",
                },
                '@media (max-width: 575px)': {
                  p: { fontSize: "12px" },
                  h3: { fontSize: "12px" },
                },
              }}
            />
          )}
        </Text>
      </Box>
    </Layout>
  );
};

export default TermOfService;
